"use client"

import { useEffect } from "react"
import { Inter } from "next/font/google"
import ErrorPage from "@/components/error-page"
import { reportClientError } from "@/lib/client-error-report"

const inter = Inter({ subsets: ["latin"] })

/**
 * global-error.tsx catches errors that occur in the root layout itself.
 * It must render its own <html> and <body> since the root layout is broken.
 */
interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    reportClientError(`global-error: ${error.stack || error.message}${error.digest ? ` (digest ${error.digest})` : ""}`)
  }, [error])

  return (
    <html lang="de">
      <body className={inter.className}>
        <main className="min-h-screen bg-gray-50">
          <ErrorPage statusCode={500} reset={reset} />
        </main>
      </body>
    </html>
  )
}
